import * as actionTypes from 'constants/ActionTypes';

export function getCargoOrders() {
    return {
        type: actionTypes.GET_CARGO_ORDERS,
    };
}

export function createCargoOrders(cargoOrders) {
    return {
        type: actionTypes.CREATE_CARGO_ORDERS,
        items: cargoOrders,
    };
}

export function clearMessage(cargoOrderKey) {
    return {
        type: actionTypes.CLEAR_CARGO_ORDER_MESSAGE,
        cargoOrderKey,
    };
}

export function updateCargoOrder(numberOrder, newCargoOrder) {
    return {
        type: actionTypes.UPDATE_CARGO_ORDER,
        numberOrder,
        newCargoOrder,
    };
}

export function addCargoOrder() {
    return {
        type: actionTypes.ADD_CARGO_ORDER,
    };
}

export function removeLastCargoOrder() {
    return {
        type: actionTypes.REMOVE_LAST_CARGO_ORDER,
    };
}

export function updateCargoOrderUser(user) {
    return {
        type: actionTypes.UPDATE_CARGO_ORDER_USER,
        user,
    };
}

export function removeAllCargoOrders() {
    return {
        type: actionTypes.REMOVE_ALL_CARGO_ORDERS,
    };
}



// WEBPACK FOOTER //
// ./app/actions/cargoes/orders.js